import React, { useEffect } from 'react'
import AboutUs from './AboutUs'
import ContentCard from './ContentCard'
import Hero from './Hero'
import LandingFeedBack from './LandingFeedBack'
import Newest from './Newest'
import PrimaryDevSkill from './PrimaryDevSkill'
import Process from './Process'

import ReactLenis from 'lenis/dist/lenis-react'
import ScrollToTop from 'src/components/ScrollToTop'

const Home: React.FC = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 500)
  }, [])

  return (
    <div className='overflow-hidden relative'>
      <ReactLenis
        root
        options={{
          lerp: 0.2
        }}
      >
        <Hero />
        <AboutUs />
        <Newest />
        <PrimaryDevSkill />
        <ContentCard />
        <Process />
        <LandingFeedBack />
        <ScrollToTop />
      </ReactLenis>
    </div>
  )
}

export default Home
